<template>
  <v-stepper v-model="stepper">
    <v-stepper-header>
      <v-stepper-step :complete="stepper > 1" step="1"
        >Auteur du document</v-stepper-step
      >
      <v-divider></v-divider>
      <v-stepper-step :complete="stepper > 2" step="2"
        >Nom du document</v-stepper-step
      >
      <v-divider></v-divider>
      <v-stepper-step step="3">Document</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-form v-model="valid_step1">
          <v-card height="100px" elevation="0">
            <v-text-field v-model="form.author" required :rules="authorRules" label="Email"></v-text-field>
          </v-card>
          <v-btn color="primary" @click="stepper = 2" :disabled="!valid_step1">Continue</v-btn>
          <v-btn text @click="stepper = 1">Annuler</v-btn>
        </v-form>
      </v-stepper-content>
      <v-stepper-content step="2">
        <v-form v-model="valid_step2">
          <v-card height="100px" elevation="0">
            <v-text-field v-model="form.title" required :rules="titleRules" label="Titre"></v-text-field>
          </v-card>
          <v-btn color="primary" @click="stepper = stepper + 1" :disabled="!valid_step2">Continue</v-btn>
          <v-btn text @click="stepper = stepper - 1">Annuler</v-btn>
        </v-form>
      </v-stepper-content>
      <v-stepper-content step="3">
        <v-card height="100px" elevation="0">
          <v-file-input v-model="form.secured_file" label="Document à transmettre"></v-file-input>
        </v-card>
        <v-btn color="primary" @click="send_file()" :disabled="!form.secured_file">Continue</v-btn>
        <v-btn text @click="stepper = stepper - 1">Annuler</v-btn>
      </v-stepper-content>
      <v-stepper-content step="4">
        <v-card height="100px" elevation="0">
          <v-alert type="success">Merci le document a été transmis et stocké de manière sécurisée. Seul son destinataire peut le lire.</v-alert>
        </v-card>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
export default {
  name: "SecureExchange",

  components: {},

  data: () => ({
    stepper: 1,
    form: {
      author: null,
      title: null,
      secured_file: null,
    },
    valid_step1: false,
    valid_step2: false,
    authorRules: [
      v => !!v || "Un email est requis",
      v => /.+@.+\..+/.test(v) || "L'email doit être valide"
    ],
    titleRules: [ v => !!v || 'Le document à envoyer doit avoir un titre', ]
  }),
  methods: {
    send_file() {
      const self = this;
      const formData = new FormData();
      formData.append("author", self.form.author);
      formData.append("title", self.form.title);
      formData.append("secured_file", self.form.secured_file);
      self.$axios
        .post("https://secure.cambiatech.com/securedfiles/", formData,
        {
          'headers': {
            'Content-Type': 'multipart/form-data'
          }
        }
        )
        .then(function(){
          self.stepper = self.stepper + 1;
        }).catch(function(error) {
          if (error.response) {
            console.log(error.response);
          }
        });
    }
  }
};
</script>
